import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { apiService } from '../../services/apiService';
import { Link, useParams } from 'react-router-dom';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

function KbAccessMemeber() {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(false);
    const [kbAccessData, setKbAccessData] = useState([]);
    const [paginatedata2, setPaginateData2] = useState({});
    const [currentPage2, setCurrentPage2] = useState(1);
    const [filter, setFilter] = useState("total_articles");
    const [selectedRecord2, setShowRecord2] = useState(20);
    
    const fetchKbAccessData = useCallback(async (page = 1, per_page = selectedRecord2) => {
        setLoading2(true);
        try {
            const response = await apiService.postRequest(`/sub-admins/${id}/kb-access`, {
                page,
                per_page,
                type: filter,
            });
            if (response && response.success) {
                setKbAccessData(response || []);
                setPaginateData2(response?.meta);
            } else {
                if (response && response.authenticate === false) {
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching group data:', error);
        } finally {
            setLoading(false);
            setLoading2(false);
        }
    }, [id, filter, selectedRecord2]);

    const handlePageChange2 = (newPage) => {
        setCurrentPage2(newPage);
        fetchKbAccessData(newPage);
    };

    // Runs on mount and whenever filter changes
    useEffect(() => {
        setCurrentPage2(1);
        fetchKbAccessData(1);
    }, [fetchKbAccessData]);

    const rows2 = kbAccessData?.data?.map((datas, index) => ({
        index: paginatedata2?.from + index,
        id: datas.article_id,
        articleFormatid: datas.formatted_id,
        access: datas.access_source,
        kbName: datas?.kb?.kb_name,
        articleTitle: datas.article_title || "N/A",
        status: datas.status || "N/A",
        roleName: datas?.role || "N/A",
        draft: datas?.article_counts?.draft,
        under_approval: datas?.article_counts?.under_approval,
        published: datas?.article_counts?.published,
        retired: datas?.article_counts?.retired,
        total: datas?.article_counts?.total,
    }));
    const columns2 = [
        {
            field: 'index',
            headerName: 'S.No',
            minWidth: 150,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'kbName',
            headerName: 'KB Name',
            minWidth: 350,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'articleTitle',
            headerName: 'Article Title',
            minWidth: 550,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                <Link className='link_datatspan' target='_blank'
                        to={ 
                            params.row.status === "draft" ?
                                `/knowledge/edit-article/${params.row.id}` :
                            params.row.status === "under_approval" ?
                                `/knowledge/under-approval/show/${params.row.id}` :
                            params.row.status === "published" ?
                                `/knowledge-article/${params.row.articleFormatid}` :
                            params.row.status === "retired" ?
                                `/knowledge/edit-article/${params.row.id}` :
                            "/knowledge"
                            }
                    >
                        {params.row.articleFormatid} - {params.row.articleTitle}
                    </Link>
                </div>
            ),
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'status',
            headerName: 'Status',
            minWidth: 350,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>
                        {params.row.status === "draft" ?
                            "Draft" :
                        params.row.status === "under_approval" ?
                            "Under Approval" :
                        params.row.status === "published" ?
                            "Published" :
                        params.row.status === "retired" ?
                            "Retired" :
                        "No Data"
                        }
                    </span>
                </div>
            ),
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'roleName',
            headerName: 'Access Groups',
            minWidth: 300,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'access',
            headerName: 'Access Source',
            minWidth: 300,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100 margin_unsetavatar'>
                    <span><b className={params.row.access === "Access Group"?'manager_groupshow':"manager_groupacees"}>{params.row.access}</b></span>
                </div>
            ),
            flex: 1,
            filterable: false,
            sortable: false,
        }
    ];
  return (
    <>
    {loading === true ?
        <div className='d-flex justify-content-center w-100' style={{minHeight:"30vh"}}>
            <img style={{ width: "100px", height: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
        </div> :
        <Grid size={{xs:12}} container className="mt-3 pb-3" style={{height:"fit-content"}}>
            <Grid size={{xs:12}} container className="gap-3 mb-4">
                <Grid size={{lg:2.8, md:2.8, xs:4}} onClick={() => setFilter("total_articles")} container flexDirection="column" alignItems="center" className={`record_cardkbaccess ${ filter === "total_articles" && "active_card"}`} >
                    <h4>{kbAccessData?.total_articles_count}</h4>
                    <h6>Total Articles</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} onClick={() => setFilter("total_kb")} container flexDirection="column" alignItems="center" className={`record_cardkbaccess ${ filter === "total_kb" && "active_card"}`}>
                    <h4>{kbAccessData?.total_kb_count}</h4>
                    <h6>Total KBs </h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} onClick={() => setFilter("owner_access")} container flexDirection="column" alignItems="center" className={`record_cardkbaccess ${ filter === "owner_access" && "active_card"}`}>
                    <h4>{kbAccessData?.kb_access?.owner_access_count}</h4>
                    <h6>Owner Of</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} onClick={() => setFilter("shared_access")} container flexDirection="column" alignItems="center" className={`record_cardkbaccess ${ filter === "shared_access" && "active_card"}`}>
                    <h4>{kbAccessData?.kb_access?.shared_access_count}</h4>
                    <h6>Access Of</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} onClick={() => setFilter("draft")} container flexDirection="column" alignItems="center" className={`record_cardkbaccess ${ filter === "draft" && "active_card"}`}>
                    <h4>{kbAccessData?.draft_count}</h4>
                    <h6>Draft</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} onClick={() => setFilter("under_approval")} container flexDirection="column" alignItems="center" className={`record_cardkbaccess ${ filter === "under_approval" && "active_card"}`}>
                    <h4>{kbAccessData?.under_approval_count}</h4>
                    <h6>Under Approval</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} onClick={() => setFilter("published_article")} container flexDirection="column" alignItems="center" className={`record_cardkbaccess ${ filter === "published_article" && "active_card"}`}>
                    <h4>{kbAccessData?.published_article_count}</h4>
                    <h6>Published</h6>
                </Grid>
                <Grid size={{lg:2.8, md:2.8, xs:4}} onClick={() => setFilter("retired")} container flexDirection="column" alignItems="center" className={`record_cardkbaccess ${ filter === "retired" && "active_card"}`}>
                    <h4>{kbAccessData?.retired_count}</h4>
                    <h6>Retired</h6>
                </Grid>
            </Grid>
            {loading2 === true ?
            <div className='d-flex justify-content-center w-100' style={{minHeight:"30vh"}}>
                <img style={{ width: "100px", height: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
            </div> :
            <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                <DataGrid
                    style={{minHeight:"200px"}}
                    rows={rows2}
                    columns={columns2}
                    disableSelectionOnClick
                    components={{ Toolbar: GridToolbar }}
                />
            </Box>}
            {kbAccessData?.data?.length > 0 &&<>
                <Grid size={{xs:12}} container justifyContent="space-between">
                    <div className='d-flex justify-content-end align-items-center mt-4'>
                        <label className='me-2'>Showing records <b>{paginatedata2.from}</b>-<b>{paginatedata2.to}</b> out of <b>{paginatedata2.total}</b></label>
                    </div>
                    <div className='d-flex justify-content-end datatable_jobpagi align-items-center mt-3'>
                        <label className='me-2'>No. of Rows</label>
                        <select
                            label="Rows per page"
                            value={selectedRecord2 || 20}
                            onChange={(e) => {
                                const value = Number(e.target.value);
                                setShowRecord2(value);
                                setCurrentPage2(1);
                            }}
                            sx={{ mr: 2 }}
                        >
                            {[5, 10, 20, 50].map((size) => (
                                <option key={size} value={size}>{size}</option>
                            ))}
                        </select>
                    </div>
                </Grid>
            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                <button className='arrowpaginate'
                    onClick={() => handlePageChange2(currentPage2 - 1)} 
                    disabled={currentPage2 === 1}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                {paginatedata2 && paginatedata2.last_page > 0 && (
                    <div className="pagination">
                        {(() => {
                        const totalPages = Math.max(1, paginatedata2.last_page);
                        const pages = [];

                        const start = Math.max(2, currentPage2 - 2);
                        const end = Math.min(totalPages - 1, currentPage2 + 2);

                        // Always show page 1
                        pages.push(
                            <button
                            key={1}
                            onClick={() => handlePageChange2(1)}
                            className={currentPage2 === 1 ? 'active' : ''}
                            >
                            1
                            </button>
                        );

                        // Ellipsis after page 1 if needed
                        if (start > 2) {
                            pages.push(<span key="start-ellipsis">...</span>);
                        }

                        // Middle pages
                        for (let i = start; i <= end; i++) {
                            pages.push(
                            <button
                                key={i}
                                onClick={() => handlePageChange2(i)}
                                className={currentPage2 === i ? 'active' : ''}
                            >
                                {i}
                            </button>
                            );
                        }

                        // Ellipsis before last page if needed
                        if (end < totalPages - 1) {
                            pages.push(<span key="end-ellipsis">...</span>);
                        }

                        // Always show last page (if more than 1)
                        if (totalPages > 1) {
                            pages.push(
                            <button
                                key={totalPages}
                                onClick={() => handlePageChange2(totalPages)}
                                className={currentPage2 === totalPages ? 'active' : ''}
                            >
                                {totalPages}
                            </button>
                            );
                        }

                        return pages;
                        })()}
                    </div>
                )}
                <button className='arrowpaginate'
                    onClick={() => handlePageChange2(currentPage2 + 1)} 
                    disabled={currentPage2 === paginatedata2.last_page}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </Grid></>}
        </Grid>
    }
    </>
  )
}

export default KbAccessMemeber
